import { lazy } from 'react';

const Agenda = lazy(() =>
  import('components/Agenda/Agenda/index').then(module => ({
    default: module.Agenda,
  }))
);

const AgendaAbogacia = lazy(() =>
  import('components/Agenda/AgendaAbogacia/index').then(module => ({
    default: module.AgendaAbogacia,
  }))
);

const routesAgenda = [
  {
    path: "/agenda-calendario",
    name: "Calendario",
    icon: "nc-icon nc-calendar-60",
    component: <Agenda />,
    permissions: ['92_CALENDARIO'],
    layout: "/app",
    visibility: true,
    subRoutes: [],
  },
  {
    path: "/agenda-juridico",
    name: "Agenda Jurídico",
    icon: "nc-icon nc-calendar-60",
    component: <AgendaAbogacia />,
    permissions: ['251_JURIDICO'],
    layout: "/app",
    visibility: true,
    subRoutes: [],
  }
]

export {
  routesAgenda
}